import { FC } from 'react';
import { Page } from 'layouts/Page';
import { SupportedCountries } from 'components/SupportedCountries';

export const SupportedCountriesPage: FC = () => {
	return (
		<Page title="Supported Countries – EAS Dashboard">
			<SupportedCountries />
		</Page>
	);
};
